(function () {
  if (window.__bundleVariationPickerReady) return;
  window.__bundleVariationPickerReady = true;

  function initPicker(picker) {
    if (!picker || picker.dataset.bundlePickerInitialized === 'true') return;

    var variantsEl = picker.querySelector('[data-bundle-variants]');
    if (!variantsEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return;
    }

    var groups = picker.querySelectorAll('[data-bundle-group]');
    var form = document.getElementById(picker.getAttribute('data-product-form-id'));
    var idInput = form && form.querySelector('[name="id"]');

    function getSelected() {
      return Array.from(groups).map(function (group) {
        var active = group.querySelector('.bundle-picker__swatch--active');
        return active && active.dataset.bundleValue;
      });
    }

    function updateVariant() {
      var selected = getSelected();
      var match = variants.find(function (variant) {
        return (
          variant.option1 === selected[0] &&
          (selected.length < 2 || variant.option2 === selected[1]) &&
          (selected.length < 3 || variant.option3 === selected[2])
        );
      });

      if (match && idInput) {
        idInput.value = match.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    picker.dataset.bundlePickerInitialized = 'true';

    picker.addEventListener('click', function (event) {
      var btn = event.target.closest('.bundle-picker__swatch');
      if (!btn) return;

      var group = btn.closest('[data-bundle-group]');
      if (!group) return;

      group.querySelectorAll('.bundle-picker__swatch').forEach(function (swatch) {
        swatch.classList.remove('bundle-picker__swatch--active');
      });
      btn.classList.add('bundle-picker__swatch--active');

      var label = group.querySelector('[data-bundle-selected-label]');
      if (label) label.textContent = btn.dataset.bundleValue;

      updateVariant();
    });

    updateVariant();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bundle-picker]').forEach(initPicker);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
